import initVivialConnectAdminAPI from "@moosetalk-frontend/global/vivialconnect-js-admin-api";
import initVivialConnectAPI from "@moosetalk-frontend/global/vivialconnect-js-api";
import config from "config.js";

const VivialConnectAPI = initVivialConnectAPI(config);
const VivialConnectAdminAPI = initVivialConnectAdminAPI(config);

export { VivialConnectAPI, VivialConnectAdminAPI };
export default VivialConnectAdminAPI;
